import { useState, useEffect } from "react";
import "./App.css";
import Header from "./Header";
import EnterInfo from "./EnterInfo";
import DatabaseEntries from "./DatabaseEntries";
import EditDatabaseEntries from "./EditDatabaseEntries";

function App() {
  const [people, setPeople] = useState([]);
  const [editOpen, setEditOpen] = useState(false);
  const [editKey, setEditKey] = useState(0);
  const [firstEntrySelected, setFirstEntrySelected] = useState(true);
  const [cancelToggle, setCancelToggle] = useState(false);

  useEffect(() => {
    const data = localStorage.getItem("people");
    if (data) {
      setPeople(JSON.parse(data));
    }
  }, []);

  useEffect(() => {
    const sortPeople = () => {
      let peopleTemp = people;
      peopleTemp = peopleTemp.sort((a, b) => {
        let firstNameA = a.firstName.toUpperCase();
        let firstNameB = b.firstName.toUpperCase();
        if (firstNameA < firstNameB) {
          return -1;
        }
        if (firstNameA > firstNameB) {
          return 1;
        }
        return 0;
      });
      console.log(peopleTemp);
    };
    sortPeople();
    localStorage.setItem("people", JSON.stringify(people));
  });

  const addPeople = (fName = "", lName = "", phone = "") => {
    let firstName = fName;
    let lastName = lName;
    let phoneNumber = phone;

    const key = Date.now();

    setPeople((prev) => {
      return [...prev, { key, firstName, lastName, phone: phoneNumber }];
    });
    // sortPeople();
    setFirstEntrySelected(false);
    setCancelToggle(false);
  };

  const deletePeople = (key) => {
    setPeople(people.filter((person) => person.key !== key));
    // sortPeople();
    setFirstEntrySelected(true);
    setCancelToggle(false);
  };

  const toggleEdit = (key) => {
    setEditOpen(!editOpen);
    setEditKey(key);
    setFirstEntrySelected(false);
    setCancelToggle(true);
  };

  const editPeople = (fName = "", lName = "", num = "", key) => {
    let firstName = fName;
    let lastName = lName;
    let phone = num;

    const updatedPerson = { firstName, lastName, phone, key };
    // let updatedPeople = people.filter((person) => person.key !== key);
    // updatedPeople = [...updatedPeople, updatedPerson];
    // setPeople(updatedPeople);
    let index = people.findIndex((element) => {
      if (element.key === key) {
        return true;
      }
      return false;
    });

    let peopleTemp = people;
    peopleTemp[index] = updatedPerson;

    setPeople(peopleTemp);
    setEditOpen(!editOpen);
    // sortPeople();
    setFirstEntrySelected(false);
    // setCancelToggle(false);
    toggleEdit(key);
  };

  return (
    <div className="App">
      <Header />
      <EnterInfo addPeople={addPeople} />
      {people.length > 0 && !editOpen && (
        <DatabaseEntries
          people={people}
          entries={people.length}
          newAdd={people[people.length - 1]}
          deletePeople={deletePeople}
          toggleEdit={toggleEdit}
          firstEntrySelected={firstEntrySelected}
          cancelToggle={cancelToggle}
          cancelKey={editKey}
        />
      )}

      {editOpen && (
        <EditDatabaseEntries
          editOpen={editOpen}
          editKey={editKey}
          people={people}
          toggleEdit={toggleEdit}
          editPeople={editPeople}
        />
      )}
    </div>
  );
}

export default App;
